import img0 from "./Images/Mobile Wallpaper/IMG_20220610_025256_202.jpg"
import img1 from "./Images/Mobile Wallpaper/IMG_20220610_025322_567.jpg"
import img2 from "./Images/Mobile Wallpaper/IMG_20220610_025517_610.jpg"
import img3 from "./Images/Mobile Wallpaper/IMG_20220610_025617_790.jpg"
import img4 from "./Images/Mobile Wallpaper/IMG_20220619_133232_862.jpg"
import img5 from "./Images/Mobile Wallpaper/IMG_20220619_133238_327.jpg";
import img6 from "./Images/Mobile Wallpaper/IMG_20220619_133243_378.jpg";
import img7 from "./Images/Mobile Wallpaper/IMG_20220619_133248_511.jpg";
import img8 from "./Images/Mobile Wallpaper/IMG_20220619_133252_572.jpg";
import img9 from "./Images/Mobile Wallpaper/IMG_20220619_133255_373.jpg";
import img10 from "./Images/Mobile Wallpaper/IMG_20220619_133259_015.jpg";
import img11 from "./Images/Mobile Wallpaper/IMG_20220619_133304_238.jpg";
import img12 from "./Images/Mobile Wallpaper/IMG_20220619_133306_901.jpg";
import img13 from "./Images/Mobile Wallpaper/IMG_20220619_133311_113.jpg";
import img14 from "./Images/Mobile Wallpaper/IMG_20220619_133314_924.jpg";
import img15 from "./Images/Mobile Wallpaper/IMG_20220619_133322_523.jpg";
import img16 from "./Images/Mobile Wallpaper/IMG_20220619_133326_351.jpg";
import img17 from "./Images/Mobile Wallpaper/IMG_20220619_133330_045.jpg";
import img18 from "./Images/Mobile Wallpaper/IMG_20220619_133334_025.jpg";
import img19 from "./Images/Mobile Wallpaper/IMG_20220619_133339_446.jpg"
import img20 from "./Images/Mobile Wallpaper/IMG_20220619_133342_287.jpg"
import img21 from "./Images/Mobile Wallpaper/IMG_20220619_133346_071.jpg"
import img22 from "./Images/Mobile Wallpaper/IMG_20220619_133349_814.jpg"
import img23 from "./Images/Mobile Wallpaper/IMG_20220619_133352_659.jpg"
import img24 from  "./Images/Mobile Wallpaper/IMG_20220619_133402_835.jpg"
import img25 from  "./Images/Mobile Wallpaper/IMG_20220619_133407_578.jpg"
import img26 from  "./Images/Mobile Wallpaper/IMG_20220619_133412_131.jpg"
import img27 from  "./Images/Mobile Wallpaper/IMG_20220619_133416_446.jpg"
import img28 from  "./Images/Mobile Wallpaper/IMG_20220619_133419_469.jpg"
import img29 from  "./Images/Mobile Wallpaper/IMG_20220619_133424_695.jpg"
import img30 from  "./Images/Mobile Wallpaper/IMG_20220619_133429_413.jpg"
import img31 from  "./Images/Mobile Wallpaper/IMG_20220619_133437_942.jpg"
import img32 from  "./Images/Mobile Wallpaper/IMG_20220619_133441_555.jpg"
import img33 from  "./Images/Mobile Wallpaper/IMG_20220619_133444_937.jpg"
import img34 from  "./Images/Mobile Wallpaper/IMG_20220619_133449_035.jpg"
import img35 from  "./Images/Mobile Wallpaper/IMG_20220619_133452_793.jpg"
import img36 from  "./Images/Mobile Wallpaper/IMG_20220619_133456_889.jpg"
import img37 from  "./Images/Mobile Wallpaper/IMG_20220619_133500_407.jpg"
import img38 from "./Images/Mobile Wallpaper/IMG_20220619_133503_572.jpg"
import img39 from "./Images/Mobile Wallpaper/IMG_20220619_133510_132.jpg";
import img40 from "./Images/Mobile Wallpaper/IMG_20220619_133512_867.jpg";
import img41 from "./Images/Mobile Wallpaper/IMG_20220619_133516_938.jpg";
import img42 from "./Images/Mobile Wallpaper/IMG_20220619_133522_620.jpg";
import img43 from "./Images/Mobile Wallpaper/IMG_20220619_133528_136.jpg";
import img44 from "./Images/Mobile Wallpaper/IMG_20220619_133531_299.jpg";
import img45 from "./Images/Mobile Wallpaper/IMG_20220619_133536_257.jpg";
import img46 from "./Images/Mobile Wallpaper/IMG_20220619_133541_911.jpg";
import img47 from "./Images/Mobile Wallpaper/IMG_20220619_133545_807.jpg";
import img48 from "./Images/Mobile Wallpaper/IMG_20220619_133549_297.jpg";
import img49 from "./Images/Mobile Wallpaper/IMG_20220619_133552_819.jpg";
import img50 from "./Images/Mobile Wallpaper/IMG_20220619_133556_776.jpg";
import img51 from "./Images/Mobile Wallpaper/IMG_20220619_133600_109.jpg";
import img52 from "./Images/Mobile Wallpaper/IMG_20220619_133604_230.jpg";
import img53 from "./Images/Mobile Wallpaper/IMG_20220619_133607_941.jpg";
import img54 from "./Images/Mobile Wallpaper/IMG_20220619_133611_370.jpg";
import img55 from "./Images/Mobile Wallpaper/IMG_20220619_133614_467.jpg";
import img56 from "./Images/Mobile Wallpaper/IMG_20220619_133617_748.jpg";
import img57 from "./Images/Mobile Wallpaper/IMG_20220610_025222_376.jpg";
import img58 from "./Images/Mobile Wallpaper/IMG_20220619_133620_898.jpg";
import img59 from "./Images/Mobile Wallpaper/IMG_20220619_133318_693.jpg";

const Mobile = () => {
    return ( 
        <section id="mobile" class="section3">
            <h2 class="h22">Mobile</h2>
            <p>browse more Mobile wallpapers.</p>
            <div class="Mrow">
                <div class="Mcolumn">
                    <img class="mobiles" src={img0} alt=""/>
                    <img class="mobiles" src={img1} alt=""/>
                    <img class="mobiles" src={img2} alt=""/>
                    <img class="mobiles" src={img3} alt=""/>
                    <img class="mobiles" src={img4} alt=""/>
                    <img class="mobiles" src={img5} alt=""/>
                    <img class="mobiles" src={img6} alt=""/>
                    <img class="mobiles" src={img7} alt=""/>
                    <img class="mobiles" src={img8} alt=""/>
                    <img class="mobiles" src={img9} alt=""/>
                    <img class="mobiles" src={img10}alt=""/>
                    <img class="mobiles" src={img11}alt=""/>
                    <img class="mobiles" src={img12} alt=""/>
                    <img class="mobiles" src={img13} alt=""/>
                    <img class="mobiles" src={img14} alt=""/>
                    <img class="mobiles" src={img15} alt=""/>
                    <img class="mobiles" src={img16} alt=""/>
                    <img class="mobiles" src={img17} alt=""/>
                    <img class="mobiles" src={img18} alt=""/>
                </div>
                <div class="Mcolumn">
                    <img class="mobiles" src={img19} alt=""/>
                    <img class="mobiles" src={img20} alt=""/>
                    <img class="mobiles" src={img21} alt=""/>
                    <img class="mobiles" src={img22} alt=""/>
                    <img class="mobiles" src={img23} alt=""/>
                    <img class="mobiles" src={img24} alt=""/>
                    <img class="mobiles" src={img25} alt=""/>
                    <img class="mobiles" src={img26} alt=""/>
                    <img class="mobiles" src={img27} alt=""/>
                    <img class="mobiles" src={img28} alt=""/>
                    <img class="mobiles" src={img29} alt=""/>
                    <img class="mobiles" src={img30} alt=""/>
                    <img class="mobiles" src={img31} alt=""/>
                    <img class="mobiles" src={img32} alt=""/>
                    <img class="mobiles" src={img33} alt=""/>
                    <img class="mobiles" src={img34} alt=""/>
                    <img class="mobiles" src={img35} alt=""/>
                    <img class="mobiles" src={img36} alt=""/>
                    <img class="mobiles" src={img37} alt=""/>
                    <img class="mobiles" src={img38} alt=""/>
                </div>
                <div class="Mcolumn">
                    <img class="mobiles" src={img39} alt=""/>
                    <img class="mobiles" src={img40} alt=""/>
                    <img class="mobiles" src={img41} alt=""/>
                    <img class="mobiles" src={img42} alt=""/>
                    <img class="mobiles" src={img43} alt=""/>
                    <img class="mobiles" src={img44} alt=""/>
                    <img class="mobiles" src={img45} alt=""/>
                    <img class="mobiles" src={img46} alt=""/>
                    <img class="mobiles" src={img47} alt=""/>
                    <img class="mobiles" src={img48} alt=""/>
                    <img class="mobiles" src={img49} alt=""/>
                    <img class="mobiles" src={img50} alt=""/>
                    <img class="mobiles" src={img51} alt=""/>
                    <img class="mobiles" src={img52} alt=""/>
                    <img class="mobiles" src={img53} alt=""/>
                    <img class="mobiles" src={img54} alt=""/>
                    <img class="mobiles" src={img55} alt=""/>
                    <img class="mobiles" src={img56} alt=""/>
                    <img class="mobiles" src={img57} alt=""/>
                    <img class="mobiles" src={img58} alt=""/>
                    <img class="mobiles" src={img59} alt=""/>
                </div>
                </div>
            </section>
     );
}
 
export default Mobile;